import { useNavigate } from "react-router-dom";
import { SubscriptionPlans } from "../components/payments";

const SubscriptionPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-20">
      <SubscriptionPlans onClose={() => navigate('/')} />
    </div>
  );
};

export default SubscriptionPage;
